<template>
<div>
  <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="老人" prop="epId">
          <el-select v-fixZoom v-model="addEditForm.epId" filterable placeholder="请选择" :clearable="true" :disabled="!isAdd" style="width:100%;" @change="elderlyChange">
            <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
              <span>{{ getSelectElderlyShow(item) }}</span>
<!--              <span style="float: left">{{ item.elderly_name }}</span>-->
<!--              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id_number }}</span>-->
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="身份证号" prop="">
          <el-input disabled v-model="addEditForm.idNumber" placeholder=""></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="床位" :prop="isAdd ? 'org' : ''">
<!--          <el-select v-fixZoom v-model="addEditForm.radio" filterable placeholder="请选择" :clearable="true" style="width:100%;" >-->
<!--            <el-option v-for="item in bedArr" :key="item.index" :label="item.name" :value="item.id"></el-option>-->
<!--          </el-select>-->
          <el-cascader v-fixZoom v-if="isAdd" v-model="addEditForm.org" placeholder="请选择" :props="optionProps" :show-all-levels="false" clearable :disabled="!isAdd" style="width: 100%"></el-cascader>
          <el-input v-else disabled v-model="addEditForm.bedName" placeholder=""></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="办理人员" prop="">
          <el-input disabled v-model="addEditForm.espName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="入住时间" prop="createTime">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.createTime"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="退住时间" prop="leaveTime">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.leaveTime"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否失能" prop="">
          <el-radio-group v-model="addEditForm.disabledElderly">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="照护等级" prop="">
          <el-select v-fixZoom v-model="addEditForm.careLevel" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in careLevelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="允许请假出院" prop="">
          <el-radio-group v-model="addEditForm.isCanRequestLeave">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="0">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="饮食级别" prop="">
          <el-input v-model="addEditForm.dietLevel" placeholder="请输入饮食级别"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {queryelderlybyid, queryhomebed} from '../../../api/yanglaoyuan'
import {queryChildrenOrgByEid, queryChildrenOrgByOrgId} from '../../../api/organizer'
import {queryOrgHomeByOrgId} from '../../../api/yanglaoyuan/orgHome'
import {bindhomebedelderly, updatehomebedelderly} from '../../../api/yanglaoyuan/homebed'
import {queryelderlynobed} from '../../../api/yanglaoyuan/elderly'

export default {
  name: 'addOldPerson',
  model: {
    prop: 'addHomeBedPersonShow',
    event: 'change'
  },
  props: {
    setHomeBedPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      optionProps: {
        value: 'id',
        label: 'name',
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let nodes = []
          if (node.level === 0) {
            nodes = await this.getOrgData()
          } else if (node.data.org_type === 0 || node.data.org_type === 1) {
            nodes = await this.getOrgChildData(node.value)
          } else if (node.data.org_type === 2) {
            nodes = await this.getOrgHomeData(node.value)
          } else {
            nodes = await this.getHomeBedData(node.value)
          }
          resolve(nodes)
        }
      },
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // }
      },
      elderlyArr: [],
      careLevelArr: [],
      isAdd: true,

      addEditForm: {
        org: [],
        idNumber: '',
        bedName: '',
        // 实体ID
        eId: 0,
        // 房间ID
        hId: 0,
        // 床位ID
        bId: '',
        // 老人ID
        epId: '',
        // 服务信息ID
        esId: 0,
        // 办理入住人员ID
        espId: 0,
        // 办理入住人员姓名
        espName: '',
        // 饮食等级
        dietLevel: '',
        // 入住时间
        createTime: '',
        // 出院时间
        leaveTime: '',
        // 护理级别
        careLevel: '1',
        // 是否允许请假出院
        isCanRequestLeave: '',
        // 是否失能
        disabledElderly: ''
      },
      addEditRules: {
        epId: [{required: true, message: '请选择老人', trigger: 'change'}],
        org: [{required: true, message: '请选择床位', trigger: 'change'}],
        createTime: [{required: true, message: '请选择入住时间', trigger: 'change'}],
        leaveTime: [{required: true, message: '请选择退住时间', trigger: 'change'}]
      },
      fileList: [
        // {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
      ]
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.addEditForm.eId = loginResp.entity_id
    this.addEditForm.espId = loginResp.syspersonid
    this.addEditForm.espName = loginResp.personname
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.getStartData()
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let idNumber = item.idcard_num && item.idcard_num !== '' ? item.idcard_num : '--'
      return elderlyName + ' / ' + idNumber
    },

    async getStartData () {
      this.isAdd = this.setHomeBedPersonObj.isAdd
      if (!this.isAdd) {
        await this.getElderlyData(1)
        let elderly = this.elderlyArr.find(r => r.id === this.setHomeBedPersonObj.row.epid)
        if (elderly) {
          this.addEditForm.idNumber = elderly.id_number
        }
        this.addEditForm.bedName = this.setHomeBedPersonObj.row.bed_name

        this.addEditForm.eId = this.setHomeBedPersonObj.row.eid
        this.addEditForm.hId = this.setHomeBedPersonObj.row.hid
        this.addEditForm.bId = this.setHomeBedPersonObj.row.bid
        this.addEditForm.epId = this.setHomeBedPersonObj.row.epid
        this.addEditForm.esId = this.setHomeBedPersonObj.row.es_id
        this.addEditForm.espId = this.setHomeBedPersonObj.row.esp_id
        this.addEditForm.espName = this.setHomeBedPersonObj.row.esp_name
        this.addEditForm.dietLevel = this.setHomeBedPersonObj.row.diet_level
        this.addEditForm.createTime = this.setHomeBedPersonObj.row.create_time
        this.addEditForm.leaveTime = this.setHomeBedPersonObj.row.leave_time
        this.addEditForm.careLevel = this.setHomeBedPersonObj.row.care_level.toString()
        this.addEditForm.isCanRequestLeave = this.setHomeBedPersonObj.row.is_can_request_leave ? parseInt(this.setHomeBedPersonObj.row.is_can_request_leave) : ''
        this.addEditForm.disabledElderly = this.setHomeBedPersonObj.row.disabled_elderly ? parseInt(this.setHomeBedPersonObj.row.disabled_elderly) : ''
      } else {
        this.addEditForm.createTime = new Date().format('yyyy-MM-dd')
        this.getElderlyData(0)
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.sendAdd()
          } else {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        id: 0,
        eid: this.addEditForm.eId,
        hid: this.addEditForm.org[this.addEditForm.org.length - 2],
        bid: this.addEditForm.org[this.addEditForm.org.length - 1],
        epId: this.addEditForm.epId,
        es_id: 0,
        esp_id: this.addEditForm.espId,
        esp_name: this.addEditForm.espName,
        diet_level: this.addEditForm.dietLevel,
        create_time: this.addEditForm.createTime,
        leave_time: this.addEditForm.leaveTime,
        is_can_request_leave: this.addEditForm.isCanRequestLeave.toString(),
        disabled_elderly: this.addEditForm.disabledElderly.toString(),
        care_level: parseInt(this.addEditForm.careLevel),
        curent_state: 0
      }
      bindhomebedelderly(data).then(res => {
        this.$notify({title: '成功', message: '成功入住', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        id: this.setHomeBedPersonObj.row.id,
        eid: this.addEditForm.eId,
        hid: this.addEditForm.hId,
        bid: this.addEditForm.bId,
        epId: this.addEditForm.epId,
        es_id: this.addEditForm.esId,
        esp_id: this.addEditForm.espId,
        esp_name: this.addEditForm.espName,
        diet_level: this.addEditForm.dietLevel,
        create_time: this.addEditForm.createTime,
        leave_time: this.addEditForm.leaveTime,
        is_can_request_leave: this.addEditForm.isCanRequestLeave.toString(),
        disabled_elderly: this.addEditForm.disabledElderly.toString(),
        care_level: parseInt(this.addEditForm.careLevel),
        curent_state: this.setHomeBedPersonObj.row.curent_state
      }
      updatehomebedelderly(data).then(res => {
        this.$notify({title: '成功', message: '成功更改入住信息', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    elderlyChange () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.epId)
      if (elderly) {
        this.addEditForm.idNumber = elderly.idcard_num
      }
    },

    // 访问接口
    // 查询老人  0为查询全部 1为根据老人ID查询
    async getElderlyData (type) {
      if (type === 0) {
        let data = {
          e_id: this.addEditForm.eId
        }
        await queryelderlynobed({}, data).then(res => {
          this.elderlyArr = res.data.elderly
        })
      } else {
        let data = {
          ep_id: parseInt(this.setHomeBedPersonObj.row.epid)
        }
        await queryelderlybyid(data).then(res => {
          let data = res.data.elderly
          let obj = {
            id: data.id,
            name: data.elderly_name,
            id_number: data.id_number
          }
          this.elderlyArr.push(obj)
        })
      }
    },
    async getOrgData () {
      let arr = []
      let data = { eid: this.addEditForm.eId }
      await queryChildrenOrgByEid(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgChildData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryChildrenOrgByOrgId(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgHomeData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryOrgHomeByOrgId(data).then(res => {
        if (res.data.orghomes) {
          res.data.orghomes.forEach(orgHome => {
            orgHome.leaf = false
            orgHome.name = orgHome.room
            arr.push(orgHome)
          })
        }
      })
      return arr
    },
    async getHomeBedData (id) {
      let arr = []
      let data = {
        hid: id,
        isbind: [0]
      }
      await queryhomebed(data).then(res => {
        if (res.data.homebed) {
          res.data.homebed.forEach(homeBed => {
            homeBed.leaf = true
            homeBed.name = homeBed.bed_name
            arr.push(homeBed)
          })
        }
      })
      return arr
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addOldPerson.vue